import { EXLY_WEBAPP_URL_SEARCH_PARAMS } from '../../constants/exly-webapp/url.js';
import { appendURLSearchParams } from '../common/url.js';

/**
 *
 * @param protocol - use window.localtion.protocol
 * @param subDomain - creator subdomain
 * @param domain - changes on the basis of the env
 * @param listingUuid - uuid of the listing we have clicked on
 * @param isCommunityOffering - whether it is a bonus offering in community or not
 * @param brandedCommunityUuid - branded community uuid
 */
var onOfferingClickInBrandedCommunity = function (_a) {
    var _b;
    var _c = _a.protocol, protocol = _c === void 0 ? "https:" : _c, subDomain = _a.subDomain, domain = _a.domain, listingUuid = _a.listingUuid, isCommunityOffering = _a.isCommunityOffering, brandedCommunityUuid = _a.brandedCommunityUuid;
    var baseUrl = "".concat(protocol, "//").concat(subDomain, ".").concat(domain, "/").concat(listingUuid);
    var urlToPush = isCommunityOffering
        ? appendURLSearchParams(baseUrl, (_b = {},
            _b[EXLY_WEBAPP_URL_SEARCH_PARAMS.COMMUNITY_ID] = brandedCommunityUuid,
            _b))
        : baseUrl;
    window.open(urlToPush, "_blank");
};

export { onOfferingClickInBrandedCommunity };
//# sourceMappingURL=BrandedCommunity.utils.js.map
